module.exports = __webpack_public_path__ + "img/SSW.02babe1d.svg";